<script>
import formatDate from '@utils/format-date'
import dialog2Mixin from "../mixins/dialog2";
import { authComputed } from "@store/helpers";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      couponList: [],
      tempCoupon: {},
      /*
         {
           "title": "測試優惠券",
           "code": "testcoupon",
           "type": "%",
           "discount": 0,
           "rebatePrice": 1
         }
       */
      couponInfo: {},
      isUnpaid: false,
      cart: {},
      priceTotal: 0,
      onChange: () => {},
    }
  },
  computed: {
    ...authComputed,
  },
  mounted() {
    this.setTempCoupon();
    this.tryToFetchMemberCouponList();
  },
  methods: {
    formatDate,
        tryTocheckMemberCoupon() {
      this.$store
        .dispatch('coupon/checkMemberCoupon', {
          code: this.tempCoupon.code,
          paramAlias: this.cart.param.alias,
          basePrice: this.isUnpaid
            ? this.cart.priceTotal
            : this.priceTotal > 0 
            ? this.priceTotal 
            : this.cart.total,
          orderUuid: !this.isLoggedIn
            ? this.cart.id
            : ''
        }).then(()=> {
          this.onChange(this.tempCoupon);
          this.dialog2MixinVisible = false;
        })
    },
    onConfirm() {
      this.tryTocheckMemberCoupon()
    },
    onClickItem(item) {
      this.tempCoupon = item
    },
    formatDiscount(type, discount) {
      switch(type) {
        case '%':
          return `${(100 - discount) / 10}`.replace('.', '');
        case 'fixed':
          return `${discount}`;
      }
    },
    tryToFetchMemberCouponList() {
      this.$store.dispatch('coupon/fetchMemberCouponList', {
        paramAlias: this.cart.param.alias,
        basePrice: this.isUnpaid
          ? this.cart.priceBase
          : this.cart.total,
        orderUuid: !this.isLoggedIn
          ? this.cart.id
          : '',
        limit: 100
      })
        .then((response) => {
          this.couponList = response.items;
        })
    },
    setTempCoupon() {
      this.tempCoupon = this.couponInfo;
    }
  },
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogCoupon } isStyleBase ${$globalIsDingBeauty ? $style.isStyleDingBeauty : ''}`"
    width="582px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogCoupon__title text-center">選取優惠券</div>
    <el-skeleton
      :loading="$isLoading('fetchMemberCouponList') && couponList.length === 0"
      animated
      :throttle="300"
    >
      <template slot="template">
        <div :class="$style.skeletonList">
          <div
            v-for="n in 3"
            :key="n"
            class="skeletonList__item"
          >
            <div>
              <el-skeleton-item
                class="skeletonList__title"
                variant="rect"
              />
              <el-skeleton-item
                class="skeletonList__description"
                variant="rect"
              />
              <el-skeleton-item
                class="skeletonList__date"
                variant="rect"
              />
            </div>
            <el-skeleton-item
              class="skeletonList__price"
              variant="rect"
            />
          </div>
        </div>
      </template>
      <template>
        <template v-if="couponList.length === 0 && !$isLoading('fetchMemberCouponList')">
          <BaseNull
            title="沒有可以使用的優惠券"
            class="mb-5"
          >
          </BaseNull>
        </template>
        <ul v-else :class="[$style.couponList, { [$style.isStyleDingBeauty]: $globalIsDingBeauty }]">
          <li
            v-for="(couponItem, index) in couponList"
            :key="index"
            class="couponList__item"
            :class="{ isActive: couponItem.code === tempCoupon.code }"
            @click="onClickItem(couponItem)"
          >
            <div>
              <div class="couponList__title">
                {{ couponItem.code }}
              </div>
              <div class="couponList__description">
                {{ couponItem.title }}
              </div>
              <div class="couponList__date">
                <span>使用期限：</span>
                <template v-if="couponItem.endDate">
                  {{ formatDate(couponItem.startDate, 'yyyy/MM/dd') }} 至
                  {{ formatDate(couponItem.endDate, 'yyyy/MM/dd') }}
                </template>
                <template v-else>
                  無期限
                </template>
              </div>
            </div>
            <div class="couponList__price">
              <el-tag :class="$globalIsDingBeauty ? 'isStyleSecondary isRadius-0' : 'isStylePrimary'">
                <template v-if="couponItem.type === '%'">
                  <span class="price">{{ formatDiscount(couponItem.type, couponItem.discount) }}</span> 折
                </template>
                <template v-if="couponItem.type === 'fixed'">
                  折抵 <span class="price">$ {{ formatDiscount(couponItem.type, couponItem.discount) }}</span>
                </template>
              </el-tag>
            </div>
          </li>
        </ul>
      </template>
    </el-skeleton>
    <BaseButton
      :disabled="!tempCoupon.code"
      class="isStylePrimary isFull mb-3"
      :class="{ 'isRadius': !$globalIsDingBeauty }"
      @click="onConfirm"
    >
      確認使用
    </BaseButton>
    <BaseButton
      class="isFull isOutline3"
      :class="{ 'isRadius isStylePrimary': !$globalIsDingBeauty, 'isStyleSecondary': $globalIsDingBeauty }"
      @click="dialog2MixinVisible = false"
    >
      取消
    </BaseButton>
    <BasePre>{{ couponList }}</BasePre>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogCoupon {
  :global {
    .dialogCoupon {
      &__title {
        margin-bottom: 2.5rem;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
      }
    }
  }
  &.isStyleDingBeauty {
    .dialogCoupon {
      &__title {
        font-size: 1.125rem;
        font-weight: 500;
      }
    }
  }
}

.couponList {
  @include list-unstyled;

  height: 421px;
  min-height: 300px;
  max-height: calc((var(--vh, 1vh) * 100) - 6vh - 367px);
  margin-bottom: 3rem;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  :global {
    .couponList {

      &__item {
        display: flex;
        justify-content: space-between;
        padding: 1.5rem 1.875rem;
        cursor: pointer;
        border: 2px solid $color-line;
        border-radius: 10px;

        @include max-md {
          display: flex;
          flex-direction: column;
        }

        &:not(:last-child) {
          margin-bottom: 1.25rem;
        }

        &:hover:not(.isActive) {
          border-color: $color-primary;
        }

        &.isActive {
          background: $color-blue;
          border-color: $color-primary;
        }
      }

      &__title {
        font-family: $font-number;
        font-size: 1.125rem;
        font-weight: 600;
        letter-spacing: 0;
      }

      &__description {
        margin-bottom: 1rem;
        font-size: 0.875rem;
        color: $color-gray-2;
      }

      &__date {
        font-size: 0.875rem;
        color: $color-gray-2;

        @include max-md {
          order: 0;
          margin-bottom: 0.5rem;
        }
      }

      &__price {
        @include max-md {
          order: 1;
        }
      }
    }
  }
  &.isStyleDingBeauty {
    :global {
      .couponList {

        &__item {
          border-radius: 0;
          border-color: $color-line;

          &.isActive {
            background: $color-primary-light;
            border-color: $color-primary;
          }
        }

        &__title {
          color: primary;
        }

        &__description {
          margin-bottom: 1rem;
          font-size: 0.875rem;
          color: $color-gray-2;
        }

        &__date {
          font-size: 0.875rem;
          color: $color-gray-2;

          @include max-md {
            order: 0;
            margin-bottom: 0.5rem;
          }
        }

        &__price {
          @include max-md {
            order: 1;
          }
        }
      }
    }
  }
}

.skeletonList {
  height: 421px;
  margin-bottom: 3rem;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }

  :global {
    .skeletonList {
      &__item {
        display: flex;
        justify-content: space-between;
        padding: 1.5rem 1.875rem;
        margin-bottom: 1.25rem;
        border: 2px solid rgba(187, 195, 201, 0.3);
        border-radius: 10px;

        @include max-md {
          display: flex;
          flex-direction: column;
        }
      }

      &__title {
        display: block;
        width: 200px;
        height: 24px;
        margin-bottom: 0.5rem;
      }

      &__description {
        display: block;
        width: 100px;
        margin-bottom: 1rem;
        font-size: 0.875rem;
      }

      &__date {
        width: 250px;
        margin-bottom: -1px;
      }

      &__price {
        width: 100px;
        height: 32px;
        margin-bottom: 0;
        border-radius: 6px;
      }
    }
  }
}
</style>
